import { useEffect, useRef } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT } from 'eco-design/elements/eco-cart/type.d';

type SvgClassNameProto = SVGAnimatedString & { includes?: (search: string, position?: number) => boolean };

export function useSvgClassNamePatch() {
    const restoreRef = useRef<(() => void) | null>(null);

    const disable = () => {
        restoreRef.current?.();
        restoreRef.current = null;
    };

    const enable = () => {
        if (restoreRef.current) return;
        const proto = typeof SVGAnimatedString !== 'undefined' ? (SVGAnimatedString.prototype as SvgClassNameProto) : null;
        if (!proto || typeof proto.includes === 'function') return;
        proto.includes = function (search, position) {
            return String(this.baseVal || '').includes(search, position);
        };
        restoreRef.current = () => {
            delete proto.includes;
        };
    };

    useEffect(() => {
        const onCartOpen = (open: boolean) => {
            if (!open) disable();
        };
        EcoDesignEventsBus.on(ENUM_ECO_CART_EVENT.ECO_CART_OPEN, onCartOpen);
        return () => {
            EcoDesignEventsBus.off(ENUM_ECO_CART_EVENT.ECO_CART_OPEN, onCartOpen);
            disable();
        };
    }, []);

    return enable;
}
